import React from 'react'
import { MenuHouper } from "../../../Controllers/Menu/MenuHouper";
import { ViewItem } from "../../Components/Classes/ViewItem";
import { HooperItemView } from "./HooperItem";
import { ContactItemView } from '../../Components/ContactItem';
import { LanguagesMenu } from './LanguagesMenu';
import {faFacebook, faInstagram} from "@fortawesome/free-brands-svg-icons";
import {faPhone} from "@fortawesome/free-solid-svg-icons";

class MenuHouperView extends ViewItem {

    get controller(): MenuHouper{
        return this.props.controller
    }

    render() {
        const {RightComponent} = this.props
        const { position, visible, hooperItems, setVisible} = this.controller
        return <div className={`menu-box-drawer ${position}-menu-box ${visible ? "menu-drawer-opened" : ""}`}>
            <div className='menu-drawer-main'>
                <div className='menu-drawer-main-box'>
                    {RightComponent && RightComponent}
                    {hooperItems && hooperItems.map(h=><HooperItemView key={h.title} title={h.title} click={h.click}/>)}
                    <LanguagesMenu/>
                </div>
            </div>
            <div className="menu-drawer-next" onClick={() => setVisible(false)}>
                <div className="menu-drawer-close-box">

                </div>
                <div
                    className={`menu-drawer-contact-info ${visible ? 'slide-in' : 'slide-out'}`}
                     onClick={(e) => e.stopPropagation()}>
                    <div className='contact-info'>
                        <ContactItemView newFA={true} title="Cell phone number" icon={faPhone} href="tel:+420776227750" value="+420 77 622 7750"/>
                        <ContactItemView
                            newFA={true}
                            title="Instagram"
                            icon={faInstagram}
                            href="https://instagram.com/chobal_restoration?igshid=YmMyMTA2M2Y="
                            value="@chobal_restoration"
                        />
                        <ContactItemView
                            newFA={true}
                            title="Facebook"
                            icon={faFacebook}
                            href="https://www.facebook.com/Chobalclassicrestoration/"
                            value="Chobalrestoration"
                        />
                    </div>
                </div>
            </div>
        </div>
    }

}

export { MenuHouperView }
